export interface ContentModel {
    header: string,
    body: string
}

export async function fetchContent(type: string) {
    let data: ContentModel = await (await fetch('/api/FetchContent?type=' + type)).json();
    data.body = data.body.search("<!DOCTYPE html>") === -1 ? data.body : "";
    return data;
}